import React, { useState, useEffect } from "react";

import Globals from "../../Globals";
import { Link } from "react-router-dom";

const API = Globals.API;

export default function VoyageB2B() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API}/events?userType=b2b`);
      const data = await res.json();
      if (data.success) {
        const filtered = data.data.filter(
          (e) => e.category === "voyage" && e.isActive
        );
        setEvents(filtered);
      }
    } catch (err) {
      console.error("Error fetching events:", err);
    } finally {
      setLoading(false);
    }
  };

  const calculateDiscount = (originalPrice, discountedPrice) => {
    if (!originalPrice || !discountedPrice || originalPrice === discountedPrice) return 0;
    return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
  };

  const getAvailableDepartures = (event) =>
  (event.departureDates || []).filter(d => d.isAvailable);

const getCheapestDeparture = (event) => {
  const deps = getAvailableDepartures(event);
  if (!deps.length) return null;

  return deps.reduce((min, curr) =>
    curr.activePricing?.price < min.activePricing?.price ? curr : min
  );
};


  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        fontFamily: "'Inter', -apple-system, sans-serif",
        padding: "60px 5%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative elements */}
      <div style={{
        position: "absolute",
        top: "-100px",
        right: "-100px",
        width: "400px",
        height: "400px",
        background: "rgba(255,255,255,0.1)",
        borderRadius: "50%",
        filter: "blur(60px)",
      }} />
      <div style={{
        position: "absolute",
        bottom: "-150px",
        left: "-150px",
        width: "500px",
        height: "500px",
        background: "rgba(255,255,255,0.08)",
        borderRadius: "50%",
        filter: "blur(80px)",
      }} />

      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "50px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "42px",
              fontWeight: "800",
              color: "white",
              margin: 0,
              marginBottom: "8px",
              letterSpacing: "-0.5px",
            }}
          >
            🌍 Voyages Exceptionnels
          </h1>
          <p style={{
            color: "rgba(255,255,255,0.85)",
            fontSize: "16px",
            margin: 0,
          }}>
            Découvrez nos destinations exclusives avec tarifs B2B privilégiés
          </p>
        </div>
        <Link
          to="/b2b"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            color: "white",
            padding: "14px 28px",
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: "14px",
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease",
            textDecoration: "none",
            display: "inline-block",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(255,255,255,0.25)";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(255,255,255,0.2)";
            e.target.style.transform = "translateY(0)";
          }}
        >
          ← Retour
        </Link>
      </div>

      {/* Loading */}
      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: "120px 0",
            color: "white",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div style={{
            display: "inline-block",
            width: "60px",
            height: "60px",
            border: "4px solid rgba(255,255,255,0.3)",
            borderTop: "4px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: "20px",
          }} />
          <p style={{ fontSize: "18px", fontWeight: 500 }}>Chargement des voyages...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      ) : events.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "120px 0",
            color: "white",
            position: "relative",
            zIndex: 1,
          }}
        >
          <i className="fa fa-compass fa-4x mb-4" style={{ opacity: 0.6 }}></i>
          <p style={{ fontSize: "20px", fontWeight: 500 }}>Aucun voyage disponible pour le moment.</p>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
            gap: "30px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {events.map((event) => {
           const cheapestDeparture = getCheapestDeparture(event);

const b2cPrice = cheapestDeparture?.pricing?.b2c?.price;
const b2bPrice =
  cheapestDeparture?.pricing?.b2b?.enabled
    ? cheapestDeparture?.pricing?.b2b?.price
    : null;

const hasDiscount = b2bPrice && b2bPrice < b2cPrice;
const discountPercent = hasDiscount
  ? calculateDiscount(b2cPrice, b2bPrice)
  : 0;


            return (
              <div
                key={event._id}
                style={{
                  background: "white",
                  borderRadius: "24px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                  overflow: "hidden",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  cursor: "pointer",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-12px) scale(1.02)";
                  e.currentTarget.style.boxShadow = "0 30px 80px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = "0 20px 60px rgba(0,0,0,0.15)";
                }}
                onClick={() => setSelectedEvent(event)}
              >
                <div style={{ position: "relative", overflow: "hidden" }}>
                  <img
                    src={event.image}
                    alt={event.title}
                    style={{
                      width: "100%",
                      height: "220px",
                      objectFit: "cover",
                      transition: "transform 0.5s ease",
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.1)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  />
                  <div style={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)",
                  }} />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "15px",
                      left: "15px",
                      background: "rgba(255,255,255,0.95)",
                      backdropFilter: "blur(10px)",
                      color: "#667eea",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "8px 16px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>📍</span>
                    {event.destination}
                  </span>
                  {cheapestDeparture && (
  <span
    style={{
      position: "absolute",
      bottom: "15px",
      right: "15px",
      background: "rgba(255,255,255,0.95)",
      padding: "8px 14px",
      borderRadius: "12px",
      fontSize: "13px",
      fontWeight: "600",
      color: "#4a5568",
    }}
  >
    🗓️ {new Date(cheapestDeparture.departureDate).toLocaleDateString()}
  </span>
)}

                  {hasDiscount && (
                    <span
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "15px",
                        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                        color: "white",
                        fontSize: "15px",
                        fontWeight: "700",
                        padding: "10px 16px",
                        borderRadius: "12px",
                        boxShadow: "0 8px 24px rgba(245,87,108,0.4)",
                      }}
                    >
                      -{discountPercent}%
                    </span>
                  )}
                </div>

                <div style={{ padding: "26px" }}>
                  <h3
                    style={{
                      fontSize: "22px",
                      fontWeight: "700",
                      color: "#1a202c",
                      marginBottom: "12px",
                      lineHeight: "1.3",
                    }}
                  >
                    {event.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#718096",
                      marginBottom: "20px",
                      minHeight: "48px",
                      lineHeight: "1.6",
                    }}
                  >
                    {event.description.slice(0, 90)}...
                  </p>

                  <div
                    style={{
                      background: "linear-gradient(135deg, #f6f8fb 0%, #eef2f7 100%)",
                      borderRadius: "16px",
                      padding: "16px 18px",
                      marginBottom: "20px",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    {hasDiscount ? (
                      <div>
                        <div style={{ marginBottom: "6px" }}>
                          <small style={{ color: "#a0aec0", textDecoration: "line-through", fontSize: "14px" }}>
                            {b2cPrice?.toFixed(2)} TND
                          </small>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <span style={{ fontSize: "24px", fontWeight: "800", color: "#f5576c" }}>
                            {b2bPrice?.toFixed(2)} TND
                          </span>
                          <span style={{ 
                            fontSize: "13px", 
                            color: "#48bb78",
                            fontWeight: "700",
                            background: "#c6f6d5",
                            padding: "4px 10px",
                            borderRadius: "8px",
                          }}>
                            Économisez {discountPercent}%
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ color: "#718096", fontSize: "14px" }}>Prix</span>
                        <span style={{ fontWeight: "800", color: "#667eea", fontSize: "20px" }}>
                          {event.price?.toFixed(2)} TND
                        </span>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        background: "linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)",
                        color: "#276749",
                        padding: "8px 14px",
                        borderRadius: "10px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      ✨ {event.includedServices?.length || 0} services
                    </span>
                    <button
                      style={{
                        border: "none",
                        background: "none",
                        color: "#667eea",
                        fontWeight: "700",
                        cursor: "pointer",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Détails
                      <span style={{ fontSize: "18px" }}>→</span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal */}
      {selectedEvent && (() => {
        const b2cPrice = selectedEvent.pricing?.b2c?.price;
        const b2bPrice = selectedEvent.pricing?.b2b?.price;
        const hasDiscount = selectedEvent.pricing?.b2b?.enabled && b2bPrice && b2cPrice && b2bPrice < b2cPrice;

        const renderPriceRow = (label, b2cVal, b2bVal) => {
          if (!b2cVal) return null;
          const discount = calculateDiscount(b2cVal, b2bVal);
          const hasItemDiscount = b2bVal && b2cVal && b2bVal < b2cVal;

          return (
            <div style={{ 
              marginBottom: "14px",
              paddingBottom: "14px",
              borderBottom: "1px solid #e2e8f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <strong style={{ color: "#4a5568", fontSize: "15px" }}>{label}</strong>
              <div style={{ textAlign: "right" }}>
                {hasItemDiscount ? (
                  <div>
                    <div>
                      <span style={{ color: "#cbd5e0", textDecoration: "line-through", fontSize: "14px" }}>
                        {b2cVal?.toFixed(2)} TND
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end" }}>
                      <span style={{ color: "#f5576c", fontWeight: "700", fontSize: "18px" }}>
                        {b2bVal?.toFixed(2)} TND
                      </span>
                      <span style={{ 
                        fontSize: "12px", 
                        color: "#48bb78",
                        fontWeight: "600",
                        background: "#c6f6d5",
                        padding: "3px 8px",
                        borderRadius: "6px",
                      }}>
                        -{discount}%
                      </span>
                    </div>
                  </div>
                ) : (
                  <span style={{ fontSize: "16px", fontWeight: "600", color: "#2d3748" }}>
                    {b2cVal?.toFixed(2)} TND
                  </span>
                )}
              </div>
            </div>
          );
        };

        return (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.7)",
              backdropFilter: "blur(8px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              padding: "20px",
              animation: "fadeIn 0.3s ease",
            }}
            onClick={() => setSelectedEvent(null)}
          >
            <style>{`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideUp {
                from { transform: translateY(30px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
              }
            `}</style>
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "white",
                borderRadius: "28px",
                maxWidth: "800px",
                width: "100%",
                padding: "0",
                boxShadow: "0 40px 120px rgba(0,0,0,0.4)",
                overflowY: "auto",
                maxHeight: "90vh",
                animation: "slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              }}
            >
              {/* Modal Header with Image */}
              <div style={{ position: "relative" }}>
                <img
                  src={selectedEvent.image}
                  alt={selectedEvent.title}
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    borderRadius: "28px 28px 0 0",
                  }}
                />
                <div style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%)",
                  borderRadius: "28px 28px 0 0",
                }} />
                <button
                  onClick={() => setSelectedEvent(null)}
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    background: "rgba(255,255,255,0.95)",
                    border: "none",
                    borderRadius: "12px",
                    width: "44px",
                    height: "44px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    color: "#4a5568",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f7fafc";
                    e.target.style.transform = "scale(1.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.95)";
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  ✕
                </button>
                <div style={{
                  position: "absolute",
                  bottom: "30px",
                  left: "40px",
                  right: "40px",
                }}>
                  <h2 style={{ 
                    color: "white", 
                    margin: 0,
                    fontSize: "32px",
                    fontWeight: "800",
                    textShadow: "0 2px 12px rgba(0,0,0,0.3)",
                  }}>
                    {selectedEvent.title}
                  </h2>
                </div>
              </div>

              {/* Modal Content */}
              <div style={{ padding: "40px" }}>
                <p style={{ 
                  color: "#4a5568", 
                  lineHeight: "1.8",
                  fontSize: "16px",
                  marginBottom: "30px",
                }}>
                  {selectedEvent.description}
                </p>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "20px",
                  marginBottom: "30px",
                }}>
                  <div style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    padding: "20px",
                    borderRadius: "16px",
                    color: "white",
                  }}>
                    <div style={{ fontSize: "24px", marginBottom: "8px" }}>📍</div>
                    <div style={{ fontSize: "13px", opacity: 0.9, marginBottom: "4px" }}>Destination</div>
                    <div style={{ fontWeight: "700", fontSize: "16px" }}>{selectedEvent.destination}</div>
                  </div>
                  
                  <div style={{
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    padding: "20px",
                    borderRadius: "16px",
                    color: "white",
                  }}>
                    <div style={{ fontSize: "24px", marginBottom: "8px" }}>🗓️</div>
                    <div style={{ fontSize: "13px", opacity: 0.9, marginBottom: "4px" }}>Programme</div>
                    <div style={{ fontWeight: "700", fontSize: "16px" }}>{selectedEvent.program}</div>
                  </div>
                </div>

                {/* Services inclus */}
                <div style={{
                  background: "linear-gradient(135deg, #f6f8fb 0%, #eef2f7 100%)",
                  padding: "24px",
                  borderRadius: "18px",
                  marginBottom: "30px",
                  border: "1px solid #e2e8f0",
                }}>
                  <h4 style={{ 
                    color: "#2d3748", 
                    marginBottom: "16px",
                    fontSize: "18px",
                    fontWeight: "700",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}>
                    <span>✨</span> Services inclus
                  </h4>
                  <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}>
                    {selectedEvent.includedServices?.map((service, idx) => (
                      <span key={idx} style={{
                        background: "white",
                        padding: "8px 16px",
                        borderRadius: "10px",
                        fontSize: "14px",
                        color: "#4a5568",
                        border: "1px solid #e2e8f0",
                        fontWeight: "500",
                      }}>
                        {service}
                      </span>
                    ))}
                  </div>
                </div>





                    {/* Departure Dates & Pricing */}
<div style={{ marginBottom: "40px" }}>
  <h4
    style={{
      fontSize: "22px",
      fontWeight: "800",
      marginBottom: "20px",
      color: "#2d3748",
    }}
  >
    🗓️ Dates & Tarifs
  </h4>

  {selectedEvent.departureDates.map((dep) => {
    const b2c = dep.pricing?.b2c || {};
    const b2bEnabled = dep.pricing?.b2b?.enabled;
    const b2b = b2bEnabled ? dep.pricing?.b2b : {};

    return (
      <div
        key={dep._id}
        style={{
          marginBottom: "24px",
          borderRadius: "18px",
          overflow: "hidden",
          border: "1px solid #e2e8f0",
          opacity: dep.isAvailable ? 1 : 0.55,
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "18px 22px",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <div>
            <div style={{ fontWeight: "700", fontSize: "16px" }}>
              ✈️ Départ :{" "}
              {new Date(dep.departureDate).toLocaleDateString()}
            </div>
            <div style={{ fontSize: "14px", opacity: 0.9 }}>
              ↩️ Retour :{" "}
              {new Date(dep.returnDate).toLocaleDateString()}
            </div>
          </div>

          <span
            style={{
              background: dep.isAvailable ? "#38a169" : "#e53e3e",
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "700",
              whiteSpace: "nowrap",
            }}
          >
            {dep.isAvailable
              ? `${dep.availableSeats} places disponibles`
              : "Complet"}
          </span>
        </div>

        {/* PRICING GRID */}
        <div
          style={{
            padding: "22px",
            background: "#f8fafc",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "14px",
            }}
          >
            {renderPriceRow(
              "Prix standard",
              b2c.price,
              b2b.price
            )}
            {renderPriceRow(
              "Demi-double",
              b2c.tarifdemidouble,
              b2b.tarifdemidouble
            )}
            {renderPriceRow(
              "Supplément single",
              b2c.spplementsingle,
              b2b.spplementsingle
            )}
            {renderPriceRow(
              "Tarif 3ème lit",
              b2c.tarif3eme,
              b2b.tarif3eme
            )}
              {renderPriceRow(
              "Enfant 0–2 ans",
              b2c.bebe,
              b2b.bebe
            )}
            {renderPriceRow(
              "Enfant 2–6 ans",
              b2c.enf2_6,
              b2b.enf2_6
            )}
            {renderPriceRow(
              "Enfant 6–12 ans",
              b2c.enf6_12,
              b2b.enf6_12
            )}
          </div>
        </div>
      </div>
    );
  })}
</div>



                {/* Pricing Details 
                <div
                  style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    padding: "28px",
                    borderRadius: "18px",
                  }}
                >
                  <h4 style={{ 
                    color: "white", 
                    marginBottom: "20px",
                    fontSize: "20px",
                    fontWeight: "700",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                    💰 Tarifs
                    {hasDiscount && (
                      <span style={{ 
                        fontSize: "14px",
                        background: "rgba(255,255,255,0.2)",
                        padding: "6px 12px",
                        borderRadius: "8px",
                        fontWeight: "600",
                      }}>
                        Prix B2B Réduits
                      </span>
                    )}
                  </h4>
                  <div style={{
                    background: "rgba(255,255,255,0.95)",
                    borderRadius: "14px",
                    padding: "20px",
                  }}>
                    {renderPriceRow("Prix standard", selectedEvent.pricing?.b2c?.price, selectedEvent.pricing?.b2b?.price)}
                    {renderPriceRow("Tarif demi-double", selectedEvent.pricing?.b2c?.tarifdemidouble, selectedEvent.pricing?.b2b?.tarifdemidouble)}
                    {renderPriceRow("Supplément single", selectedEvent.pricing?.b2c?.spplementsingle, selectedEvent.pricing?.b2b?.spplementsingle)}
                    {renderPriceRow("Tarif 3ème lit", selectedEvent.pricing?.b2c?.tarif3eme, selectedEvent.pricing?.b2b?.tarif3eme)}
                    {renderPriceRow("Enfant 2-6 ans", selectedEvent.pricing?.b2c?.enf2_6, selectedEvent.pricing?.b2b?.enf2_6)}
                    {renderPriceRow("Enfant 6-12 ans", selectedEvent.pricing?.b2c?.enf6_12, selectedEvent.pricing?.b2b?.enf6_12)}
                  </div>
                </div>*/}

                <button
                  onClick={() => setSelectedEvent(null)}
                  style={{
                    marginTop: "24px",
                    padding: "16px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "14px",
                    cursor: "pointer",
                    width: "100%",
                    fontSize: "16px",
                    fontWeight: "700",
                    transition: "all 0.3s ease",
                    boxShadow: "0 8px 24px rgba(102,126,234,0.4)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 12px 32px rgba(102,126,234,0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 8px 24px rgba(102,126,234,0.4)";
                  }}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}